import React from 'react';
import { Redirect } from 'react-router-dom';
import client from './apolloClient';
import gql from 'graphql-tag';
import { getUser } from '../data-services/queries';

export default function (ComposedComponent) {
    class Authenticate extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                loading: true,
                user: null,
            };
        }

        componentDidMount() {
            client
                .query({
                    query: gql(getUser),
                })
                .then(({ data }) => {
                    //console.log("data",data)
                    if (data) {
                        this.setState({
                            loading: false,
                            user: data.user,
                        });
                    } else {
                        this.setState({
                            loading: false,
                        });
                    }
                });
        }

        componentDidUpdate() {
            // this._checkAndRedirect();
        }

        async _checkAndRedirect() {
            const token = localStorage.getItem('token');

            if (token) {
                return true;
            } else {
                throw new Error('Unauthenticated');
            }
        }

        render() {
            if (this.state.loading) {
                return <h1>Loading...</h1>;
            }

            if (this.state.user) {
                return <ComposedComponent {...this.props} />;
            } else {
                return <Redirect to="/signin" />;
            }
        }
    }
    return Authenticate;
}
